// SuccessMessage Component
export const SuccessMessage = ({ message }) => {
    return (
        <div className="success-message">
            {message}
        </div>
    );
};

export default SuccessMessage;